import { Tag } from 'antd';
import { DEAL_SUBMISSION_MATCH_STATUS_TITLES } from '@zorba-shared/core/Constants/offer';
import {
  getFormattedTimeInEST,
  getPriceText,
} from '@zorba-shared/core/Services/textService';
import { setSelectedOffer } from '../../../../../../reducers/Offer/actions';

export const getTableColumns = (dispatch) => [
  {
    title: 'Address',
    key: 'address',
    render: (record) => (
      <span
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={() => {
          dispatch(setSelectedOffer(record));
        }}
      >
        {record.address}
      </span>
    ),
  },
  {
    title: 'Initially sent on',
    key: 'createdAt',
    render: ({ createdAt }) => getFormattedTimeInEST(createdAt),
  },
  {
    title: 'Status',
    key: 'status',
    render: ({ status }) => (
      <Tag>{DEAL_SUBMISSION_MATCH_STATUS_TITLES[status]}</Tag>
    ),
    filters: Object.entries(DEAL_SUBMISSION_MATCH_STATUS_TITLES).map(
      ([value, text]) => ({
        text,
        value,
      }),
    ),
    onFilter: (value, record) => record.status === value,
  },
  {
    title: 'Actual buyer',
    key: 'buyer',
    render: ({ buyer }) => buyer,
  },
  {
    title: `Zorba's asking price`,
    key: 'askingPrice',
    render: ({ askingPrice }) => getPriceText(askingPrice),
  },
  {
    title: `Your offer`,
    key: 'offer',
    render: ({ offer }) => (offer ? getPriceText(offer) : ''),
  },
  {
    title: `Sale price`,
    key: 'salePrice',
    render: ({ salePrice, offer }) => {
      if (!salePrice || Number(salePrice) <= 0) return 'N/D';

      const priceText = getPriceText(salePrice);
      if (!offer) return priceText;

      const percentageDiff = (((salePrice - offer) / offer) * 100).toFixed(1);
      const sign = percentageDiff >= 0 ? '+' : '';
      return `${priceText} (${sign}${percentageDiff}%)`;
    },
  },
  {
    title: `Sale Date`,
    key: 'saleDate',
    render: ({ saleDate }) => getFormattedTimeInEST(saleDate),
    sorter: (a, b) => {
      if (!a.saleDate) return 1;
      if (!b.saleDate) return -1;
      return new Date(a.saleDate) - new Date(b.saleDate);
    },
  },
];
